<template>
  <div>
    <div class="column columns redeem_form mw100">
      <div class="column">
        <div class="column">
          <div
            class="column"
            v-bind:class="{'has_error':!validation.amount || minBlue > bluAmount }"
          >
            <p class="tal_c">{{$t("msg.input_amount_withdraw")}}</p>

            <div class="column blu_input_container">
              <img class="blu_input_img" src="../../../../assets/images/stratumBlue-icon.svg" />
              <div class="blu_input">
                <input class="amount_redeem" v-model="bluAmount" v-on:keypress="isNumber()" />
              </div>
              <div class="blu_input_actions">
                <div class="blu_input_plus" @click="modifyBluAmount('+')">
                  <p v-html="iconSets.general_up"></p>
                </div>
                <div
                  class="blue_input_minus"
                  @click="modifyBluAmount('-')"
                  v-bind:class="{'arrow_disabled':parseFloat(bluAmount) <= parseFloat( minBlue)}"
                >
                  <p v-html="iconSets.general_down"></p>
                </div>
              </div>
            </div>
            <p class="tal_c">
              <span
                class="text_sm has_error_text"
                v-if="!validation.amount || bluAmount < minBlue"
              >{{$t('msg.invalid_amount')}}.</span>
            </p>

            <div class="column text_sm" style="display:flex; align-items:center"></div>
          </div>
          <div class="column">
            <div class="component_border_bottom">
              <span></span>
            </div>
          </div>
          <div class="column tal_r">
            <!-- <p
              class="fat"
            >{{$tc("msg.fee", 1)}}: {{xemToBlu(xemValue[0].value * feeWithdraw).toFixed(6)}} BLUE</p> -->
            <!-- <p
              class="fat capitalize"
              v-bind:class="{'notice': bluAmount < minBlue}"
            >{{$t("msg.min")}}: {{bluValue[0].withdrawMinimal}} BLU</p> -->
          </div>
          <div class="column">
            <p v-html="$t('msg.send_to_blu_adress')"></p>
            <div class="custom-flex">
              <div class="icon-container"><i v-html="iconSets.blu_wallet" class="icon_class_2 m_auto"></i></div>
              <input
                class="amount_address"
                type="text"
                v-model="address"
                style="width:100%;"
                @keyup="validateAdress(address)"
              />
            </div>
            <p class="tal_c">
              <span
                class="text_sm has_error_text"
                v-if="validation.address"
              >{{$t("msg.error_withdraw_address")}}</span>
            </p>
            <p class="fat upper m13_t">{{$t("msg.tag")}}</p>
            <input
              class="amount_address"
              type="number"
              v-model="externalId"
              style="width:100%;"
              @keyup="validateAdress(address)"
            />
            <div class="column">
              <p class="text_ssm">{{$t("msg.tag_important")}}</p>
            </div>
          </div>
          <div class="column">
            <button
              class="btn_redeem"
              @click="callNextStep()"
              :disabled="validation.address || externalId == '' || !validation.amount"
            >{{$t("msg.next_step")}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.checkAmount();
    this.getWithdrawFee();
  },
  mounted() {},
  data: () => ({
    redeem_error: "",
    bluAmount: 0,
    minBlue: 0,
    maxBluAmount: 99999999999,
    address: "",
    unLockedBalance: "",
    externalId: "",
    feeWithdraw: "",
    validation: {
      amount: false,
      address: false
    },
  }),
  components: {},
  methods: {
    setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },

    callNextStep() {
      this.$emit("callNext", this.bluAmount, this.address, this.externalId);
    },

    async getWithdrawFee() {
      let resp = await this.$store.dispatch("getFees");
      let fees = resp.data;

      let arrayFee = [];

      for (let i in fees) {
        if (fees[i].type == "withdraw") {
          arrayFee.push(fees[i].fee);
        }
      }
      this.feeWithdraw = arrayFee[arrayFee.length - 1];
    },

    xemToBlu(amount) {
      let xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },

    setMinAmount() {
      let bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      this.bluAmount = this.minBlue;
    },

    checkAmount() {

      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },

    validateAmount() {
      this.bluAmountValid = false;
      let indices = [];
      let amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },

    isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },

    getUnlockedBalance() {
      if (this.bluAccount) {
        let totalBalance = this.bluAccount.balance;
        let lockedBalace = this.bluAccount.locked;
        let unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },

    validateAdress(address) {
      if (address.length > 10 && address.charAt(0) === "N" || address.charAt(0) === "T") {
        this.validation.address = false;
      } else {
        this.validation.address = true;
      }
    },


    modifyBluAmount(modifier) {
      if (
        this.bluAmount == false ||
        this.bluAmount < this.minBlue ||
        this.bluAmount == ""
      ) {
        this.bluAmount = this.minBlue;
      } else {
        let vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          let result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },

    roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },

    isNumber() {
      let evt = window.event;
      var charCode = evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  computed: {
    ...mapGetters([
      "btcValue",
      "bluValue",
      "bluAccount",
      "ethValue",
      "xemValue"
    ]),

  },
  watch: {
    bluAmount: function() {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function() {
      this.setMinAmount();
    }
  }
};
</script>
<style scoped>
   .icon-container{
    background: white;
    width: 70px;
    border-style: solid;
    border-width: 1px 0px 1px 1px;
    border-color: #e3d4d4;
    display: flex;
  }
</style>


// WEBPACK FOOTER //
// src/components/private/services/withdraw_steps/WithdrawStep1.vue